import "../styles/globals.css";
import "../styles/yopta.css";
import "@blocknote/core/style.css";
import "regenerator-runtime/runtime";
import type { AppType } from "next/app";
import type { ComponentType, ReactNode } from "react";
import type { Session } from "next-auth";
import { Analytics } from "@vercel/analytics/react";
import Script from "next/script";
import { useMemo } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";

type AppShellRuntimeProps = {
  session: Session | null;
  children: ReactNode;
};

const AppShellRuntime = dynamic<AppShellRuntimeProps>(
  () =>
    import("../app-shell-runtime").then(
      (mod) => mod.AppShellRuntime as ComponentType<AppShellRuntimeProps>,
    ),
  { ssr: false },
);

const APP_SHELL_ROUTES = new Set([
  "/chat",
  "/note",
  "/settings",
  "/extension",
  "/dnd",
  "/test",
  "/subscribe",
]);

const MyApp: AppType<{ session: Session | null }> = ({
  Component,
  pageProps: { session, ...pageProps },
}) => {
  const router = useRouter();
  const isAppShellRoute = useMemo(() => APP_SHELL_ROUTES.has(router.pathname), [router.pathname]);

  if (isAppShellRoute) {
    return (
      <AppShellRuntime session={session}>
        <Component {...pageProps} />
      </AppShellRuntime>
    );
  }

  return (
    <>
      <Component {...pageProps} />
      <Analytics />
      <Script
        strategy="lazyOnload"
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-LNPGYKL8FV"
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-LNPGYKL8FV', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    </>
  );
};

export default MyApp;
